/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../services";

@Component({
  selector: "app-template",
  templateUrl: "./template.component.html"
})
export class TemplateComponent implements OnInit {
  constructor(private authService: AuthService) {}

  menuCollapsed = true;
  isUserLogged = false;
  ngOnInit(): void {
    this.isUserLogged = this.authService.isUserLogged();
    if (this.isUserLogged) {
      this.menuCollapsed = false;
    }
  }

  receiveMenuCollapseEvent(menuCollapseEvent: boolean) {
    this.menuCollapsed = menuCollapseEvent;
  }
}
